import {
  ApiIntegrationEmployeeLinkStatus,
  ApiIntegrationEmployeesType,
  ApiIntegrationType,
} from "@/types/integrations/integration.types.ts";
import { Button, EmptyStateBase } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface Props {
  integrationId: number;
  integrationType: ApiIntegrationEmployeesType;
  notFoundEmployeesCount: number;
}

export function SettingsIntegrationNotFoundBanner({
  integrationId,
  integrationType,
  notFoundEmployeesCount,
}: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (notFoundEmployeesCount === 0) return null;

  const descriptions: Record<ApiIntegrationEmployeesType, string> = {
    [ApiIntegrationType.slack]: t("integrations:slack_employees_not_found_description"),
    [ApiIntegrationType.google_calendar_service_account]: t(
      "integrations:google_calendar_employees_not_found_description"
    ),
  };

  return (
    <EmptyStateBase
      emoji={null}
      title={t("integrations:employees_not_found_count", { count: notFoundEmployeesCount })}
      description={descriptions[integrationType]}
      variant={"primary"}
      className={"container-sm mx-auto mt-8"}
      primaryButton={
        <Button
          onClick={() =>
            navigate(
              `/settings/integrations/${integrationId}/${integrationType}/employees?statuses=${ApiIntegrationEmployeeLinkStatus.not_found}`
            )
          }
        >
          {t("time_off:review_employees")}
        </Button>
      }
    />
  );
}
